import { createContext, ReactNode, useContext } from 'react';

interface PageTitleContextValue {
  title: string;
  setTitle: (title: string) => void;
  headerActions: ReactNode | null;
  setHeaderActions: (actions: ReactNode | null) => void;
  extraHeaderActions: ReactNode | null;
  setExtraHeaderActions: (actions: ReactNode | null) => void;
  headerHidden: boolean;
  setHeaderHidden: (hidden: boolean) => void;
  headerRows: number;
  setHeaderRows: (rows: number) => void;
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
}

export const PageTitleContext = createContext<PageTitleContextValue>({
  title: '',
  setTitle: () => {},
  headerActions: null,
  setHeaderActions: () => {},
  extraHeaderActions: null,
  setExtraHeaderActions: () => {},
  headerHidden: false,
  setHeaderHidden: () => {},
  headerRows: 1,
  setHeaderRows: () => {},
  sidebarCollapsed: false,
  toggleSidebar: () => {},
});

export const usePageTitle = () => useContext(PageTitleContext);
